import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../../Moduels/Context/AuthContext";
import { normalizeRole } from "../../../rbac/access";
import WfDashboard from "./WfDashboard";

/** HR/admin dashboard — employees are sent to their self-service page. */
export default function AttendanceDashboardGate() {
  const { role } = useContext(AuthContext);
  if (normalizeRole(role) === "employee") {
    return <Navigate to="/my-attendance" replace />;
  }
  return <WfDashboard />;
}
